import { LuneTheme } from '@lune-fe/lune-ui-lib'
import Link from '@mui/material/Link'
import { styled } from '@mui/material/styles'
import Text from '@mui/material/Typography'

import AccordionTile from '@/components/AccordionTile'

export default function EmissionCalcsFaq() {
    const { palette } = LuneTheme
    const StyleLink = styled(Link)(
        LuneTheme.unstable_sx({
            color: palette.Grey600,
            textDecorationColor: palette.Grey600,
        }),
    )
    return (
        <>
            <Text variant={'h6'} sx={{ mb: 5 }}>
                FAQs
            </Text>
            <AccordionTile
                title={`How are emissions measured?`}
                description={
                    <>
                        Emissions are generally measured in tCO₂e, which stands for metric tonnes of
                        carbon dioxide equivalent. For smaller amounts of emissions, the unit can
                        also be expressed in kgCO₂e or gCO₂e.{' '}
                        <StyleLink
                            target={'_blank'}
                            href={'https://docs.lune.co/general-concepts/emission-calculations'}
                        >
                            Learn more
                        </StyleLink>
                        .
                    </>
                }
            />
            <AccordionTile
                title={`How does Lune calculate emissions?`}
                description={
                    <>
                        {`Lune's emission calculation methodology is anchored in the GHG Protocol, the leading international carbon accounting standard. Lune's emission intelligence matches spend- and activity-data with the most relevant emission factor to calculate granular emissions.`}
                        <br />
                        <br />
                        <StyleLink
                            target={'_blank'}
                            href={'https://lune.co/blog/what-is-an-emissions-factor'}
                        >
                            Learn more about emission factors
                        </StyleLink>
                        .
                    </>
                }
            />
            <AccordionTile
                title={`Are Lune's calculations certified?`}
                description={
                    <>
                        {`Lune's calculations are audited and certified by ISO-14064. ISO 14064 is an international standard for quantifying and reporting greenhouse gas emissions and removals. The certification assures end-users that Lune's emission calculation methodology and outputs are robust and can support reliable carbon reporting.`}
                    </>
                }
            />
            <AccordionTile
                title={`How can your company use these insights?`}
                description={
                    <>
                        {`You can use these insights in company sustainability reports. If you, or your customers, are estimating a company's carbon footprint the above data can be aggregated and included as part of the company's scope 3 emissions.`}
                        <br />
                        <br />
                        If you do not yet calculate your own carbon footprint, keep in mind that you
                        may have to do so starting from 2024, due to the EU Corporate Sustainability
                        Reporting Directive (CSRD), and other upcoming regulation.{' '}
                        <StyleLink
                            target={'_blank'}
                            href={'https://lune.co/blog/what-is-an-emissions-factor'}
                        >
                            Learn more about the EU CSRD
                        </StyleLink>
                        .
                    </>
                }
            />
        </>
    )
}
